export default __webpack_public_path__ + "static/media/logo_inverted.5ba8702e.jpg";